import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Components/Navbar/13.png';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Waves, Phone, Mail, Clock, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-cyan-900 text-white">
      {/* Ocean wave pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)',
        }}></div>
      </div>
      
      <div className="relative container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <img src={logo} alt="Oceanique Logo" className="w-32 h-32 object-contain bg-white/10 rounded-full p-3" />
              <div>
                <h3 className="text-2xl font-bold font-serif">Oceanique</h3>
                <p className="text-cyan-300 text-sm">Medical Spa & Wellness</p>
              </div>
            </div>
          </div>
          
          {/* Contact Information */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold font-serif mb-4 flex items-center gap-2">
              <span className="w-8 h-1 bg-cyan-400 rounded-full"></span>
              Contact Us
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-blue-100 hover:text-white transition-colors">
                <MapPin className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p>7025 Beracasa Way, 103C</p>
                  <p>Boca Raton, FL 33433</p>
                </div>
              </div>
              <a href="tel:5619906745" className="flex items-center gap-3 text-blue-100 hover:text-white transition-colors">
                <Phone className="w-5 h-5 text-cyan-400" />
                <span>(561) 990-6745</span>
              </a>
              <a href="mailto:info@oceaniquebodycare.com" className="flex items-center gap-3 text-blue-100 hover:text-white transition-colors">
                <Mail className="w-5 h-5 text-cyan-400" />
                <span>info@oceaniquebodycare.com</span>
              </a>
              <div className="flex items-center gap-3 text-blue-100">
                <Clock className="w-5 h-5 text-cyan-400" />
                <div>
                  <p>Mon-Fri | 9am - 5pm</p>
                  <p className="text-sm text-cyan-300">*APPOINTMENT ONLY*</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Quick Links & Social */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold font-serif mb-4 flex items-center gap-2">
              <span className="w-8 h-1 bg-cyan-400 rounded-full"></span>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-blue-100 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-cyan-400 rounded-full"></span>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-blue-100 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-cyan-400 rounded-full"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/before-after" className="text-blue-100 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-cyan-400 rounded-full"></span>
                  Before & After
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-blue-100 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2">
                  <span className="w-1 h-1 bg-cyan-400 rounded-full"></span>
                  Book Appointment
                </Link>
              </li>
            </ul>
            
            {/* Social Media */}
            <div className="pt-4">
              <p className="text-sm text-blue-200 mb-3">Follow Us</p>
              <div className="flex gap-3">
                <a 
                  href="https://www.facebook.com/profile.php?id=100077993940572" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <FaFacebookF size={18} />
                </a>
                <a 
                  href="https://www.instagram.com/sasbodyworks/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <FaInstagram size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright Bar */}
        <div className="mt-12 pt-8 border-t border-blue-700/50">
          <div className="text-center">
            <div className="text-blue-200 text-sm">
              &copy; {new Date().getFullYear()} Oceanique Medical Spa. All rights reserved.
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative wave at top */}
      <div className="absolute top-0 left-0 right-0 overflow-hidden h-px">
        <div className="h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent"></div>
      </div>
    </footer>
  );
};

export default Footer;
